import { ChartOptions } from 'chart.js';
import { TaskData } from '../constants/types';
import { getTotalTasks } from './getTotalTasks';

export const getPieChartOptions = ( chartData: TaskData, clickedSegment: number | null, setClickedSegment: (i: number | null) => void): ChartOptions<'pie'> => ({
    responsive: true,
    animation: {
      animateRotate: true,
      duration: 1000,
    },
    plugins: {
      legend: { 
        display: true,
        align: "start",
        labels: 
      {
        font: 
        {
          family: "'Inter', sans-serif",  
          size: 14,                                                  
        },
      },
      },
      datalabels:{
        color: '#ffffff',
        font: {
          family: "'Inter', sans-serif",
          size: 12,
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const value = context.parsed;
            const percentage = ((value / total) * 100).toFixed(1);
            return `${context.label}`;
          }
        }
      },
      title: {
        display: true,
        text: 'Total Services: '+ getTotalTasks(chartData),
        font: 
          {
            family: "'Inter', sans-serif",
            size: 18,
            weight: 550
          },
      }
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const clickedIndex = elements[0].index;

        // If clicked segment is the same as previously clicked, reset it
        if (clickedSegment === clickedIndex) {
          setClickedSegment(null);  // Reset to original state
        } 
        else {
          setClickedSegment(clickedIndex);  // Set new clicked segment to move out
        }
      }
    }
});